<template>
    <div v-loading="loading" class="portfolio-work-state" v-if="loading || getUser.foreignJobStatusId || getUser.salaryLevel">
        <div>
            <div
                v-if="getUser.foreignJobStatusId"
                class="portfolio-work-state-badge"
                :class="{
                    [`portfolio-work-state-badge--${badgeModifier}`]: true,
                }"
            >
                {{ state }}
            </div>
        </div>
        <div>
            Желаемый уровень зарплаты:
            <span class="portfolio-work-state-salary">{{ salary }}</span>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    data: () => ({
        loading: false,
    }),

    async created() {
        this.loading = true;

        await this.loadRegistryItems({ type: 'job_status' });

        this.loading = false;
    },

    computed: {
        ...mapGetters('newUsers', [
            'getUser',
        ]),
        ...mapGetters('data', [
            'getRegistryItems',
        ]),

        state() {
            const status = this.getUser.foreignJobStatusId;

            if (!status) {
                return '';
            }

            const statusData = this.getRegistryItems('job_status').find(v => v.id === status);

            return statusData ? statusData.field_value : '';
        },

        badgeModifier() {
            const status = this.getUser.foreignJobStatusId;

            if (!status) {
                return 'empty';
            }

            return 'green';
        },

        salary() {
            if (!this.getUser.salaryLevel) {
                return 'не указан';
            }

            const formatter = Intl.NumberFormat('ru', {
                maximumFractionDigits: 0,
            });

            return formatter.format(this.getUser.salaryLevel) + " р.";
        },
    },
    methods: {
        ...mapActions('data', [
            'loadRegistryItems',
        ]),
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.portfolio-work-state {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    gap: mrem(16);

    @include on-desktop {
        gap: rem(16);
        align-items: center;
        flex-direction: row;
    }

    .portfolio-work-state-badge {
        display: flex;
        padding: mrem(8) mrem(10);
        gap: mrem(10);
        border-radius: mrem(120);
        font-style: normal;
        font-weight: 600;

        @include on-desktop {
            padding: rem(8) rem(10);
            gap: rem(10);
            border-radius: rem(120);

            align-items: flex-start;
        }

        &--empty {
            display: none;
        }

        &--green {
            background: #E5FFEA;
        }
    }

    .portfolio-work-state-salary {
        display: block;
        font-style: normal;
        font-weight: 600;
        font-size: mrem(18);
        line-height: mrem(24);

        @include on-desktop {
            display: inline-block;
            font-size: rem(18);
            line-height: rem(24);
        }
    }
}

</style>
